import { Box, Stack, Text } from '@chakra-ui/react';
import { Grid, gridConfig } from '@time-line/components/common';
import type { Timeline as TimelineProps } from 'types/cms/blocks/Timeline';

import { TimelineColumn } from '../TimelineColumn';
import { TimelineScrollbar } from '../TimelineScrollbar';
import { calcEmptyFollowingYears } from '../utils';

const { borderWidthClamp } = gridConfig;

export function Timeline({ title, years }: TimelineProps) {
  if (!years) {
    return null;
  }

  return (
    <Grid
      withBorder
      py="xl"
      borderRadius="lg"
      bg="gray.100"
      overflowX="hidden"
      mb={borderWidthClamp}
    >
      <Grid.Inner mb="m">
        <Text textAlign="center" as="h2" size="h2" gridColumn="span 12">
          {title}
        </Text>
      </Grid.Inner>
      <Grid.Inner gridColumn="full">
        <Box gridColumn="span 12">
          <TimelineScrollbar>
            <Stack direction="row" spacing={0} alignItems="stretch" h="100%">
              {years.map((yearData, i) => (
                <TimelineColumn
                  key={yearData.year}
                  year={yearData.year}
                  events={yearData.events}
                  numOfEmptyYears={calcEmptyFollowingYears(
                    yearData.year,
                    years,
                  )}
                  isLast={i + 1 === years.length}
                />
              ))}
            </Stack>
          </TimelineScrollbar>
        </Box>
      </Grid.Inner>
    </Grid>
  );
}
